import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useLocation, useNavigate, Link } from 'react-router-dom';
import { api } from '../api/client';
import ScoreRing from '../components/analyzer/ScoreRing';
import SourceCard from '../components/analyzer/SourceCard';
import ModusOperandiCard from '../components/analyzer/ModusOperandiCard';
import EntityList from '../components/analyzer/EntityList';
import DomainEmailsCard from '../components/analyzer/DomainEmailsCard';
import SmartSummary from '../components/analyzer/SmartSummary';
import CollapsibleSection from '../components/common/CollapsibleSection';
import Breadcrumb from '../components/common/Breadcrumb';

function BadgeIcon({ icon }) {
  const cls = "w-3.5 h-3.5";
  switch (icon) {
    case 'fire':
      return <svg className={cls} viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M12.395 2.553a1 1 0 00-1.45-.385c-.345.23-.614.558-.822.88-.214.33-.403.713-.57 1.116-.334.804-.614 1.768-.84 2.734a31.365 31.365 0 00-.613 3.58 2.64 2.64 0 01-.945-1.067c-.328-.68-.398-1.534-.398-2.654A1 1 0 005.05 6.05 6.981 6.981 0 003 11a7 7 0 1011.95-4.95c-.592-.591-.98-.985-1.348-1.467-.363-.476-.724-1.063-1.207-2.03zM12.12 15.12A3 3 0 017 13s.879.5 2.5.5c0-1 .5-4 1.25-4.5.5 1 .786 1.293 1.371 1.879A2.99 2.99 0 0113 13a2.99 2.99 0 01-.879 2.121z" clipRule="evenodd" /></svg>;
    case 'sparkle':
      return <svg className={cls} viewBox="0 0 20 20" fill="currentColor"><path d="M5 2a1 1 0 011 1v1h1a1 1 0 010 2H6v1a1 1 0 01-2 0V6H3a1 1 0 010-2h1V3a1 1 0 011-1zm0 10a1 1 0 011 1v1h1a1 1 0 110 2H6v1a1 1 0 11-2 0v-1H3a1 1 0 110-2h1v-1a1 1 0 011-1zm7-10a1 1 0 01.967.744L14.146 7.2 17.5 7.512a1 1 0 01.576 1.765l-2.588 2.16.86 3.388a1 1 0 01-1.504 1.09L12 13.798l-2.844 2.117a1 1 0 01-1.504-1.09l.86-3.388-2.588-2.16a1 1 0 01.576-1.765l3.354-.312 1.179-3.456A1 1 0 0112 2z" /></svg>;
    case 'clock':
      return <svg className={cls} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>;
    case 'repeat':
      return <svg className={cls} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M19.5 12c0-1.232-.046-2.453-.138-3.662a4.006 4.006 0 00-3.7-3.7 48.678 48.678 0 00-7.324 0 4.006 4.006 0 00-3.7 3.7c-.017.22-.032.441-.046.662M19.5 12l3-3m-3 3l-3-3m-12 3c0 1.232.046 2.453.138 3.662a4.006 4.006 0 003.7 3.7 48.656 48.656 0 007.324 0 4.006 4.006 0 003.7-3.7c.017-.22.032-.441.046-.662M4.5 12l3 3m-3-3l-3 3" /></svg>;
    case 'users':
      return <svg className={cls} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" /></svg>;
    case 'money':
      return <svg className={cls} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M14.25 7.756a4.5 4.5 0 100 8.488M7.5 10.5h5.25m-5.25 3h5.25M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>;
    case 'shield':
      return <svg className={cls} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z" /></svg>;
    case 'trend_up':
      return <svg className={cls} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M2.25 18L9 11.25l4.306 4.307a11.95 11.95 0 015.814-5.519l2.74-1.22m0 0l-5.94-2.28m5.94 2.28l-2.28 5.941" /></svg>;
    case 'trend_down':
      return <svg className={cls} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6L9 12.75l4.286-4.286a11.948 11.948 0 014.306 6.43l.776 2.898m0 0l3.182-5.511m-3.182 5.51l-5.511-3.181" /></svg>;
    case 'calendar':
      return <svg className={cls} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5" /></svg>;
    default:
      return null;
  }
}

function isUUID(str) {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(str);
}

export default function AnalysisResultPage() {
  const { t } = useTranslation();
  const { identifier } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const decoded = decodeURIComponent(identifier);
    const stateId = location.state?.analysisId;

    const loadResult = async (analysisId) => {
      try {
        const res = await api.getAnalysis(analysisId);
        if (!res.data.is_complete) {
          // Not done yet — redirect to scan page
          navigate(`/scan/${analysisId}`, {
            replace: true,
            state: { analysisId, identifier: decoded },
          });
          return;
        }
        setResult(res.data);
      } catch (err) {
        setError(t('result.notFoundError'));
      }
    };

    if (stateId) {
      loadResult(stateId);
    } else if (isUUID(decoded)) {
      loadResult(decoded);
    } else {
      // Identifier is an email, phone, or pseudo — lookup the latest analysis
      const isPhone = /^\+?\d[\d\s\-.()]{6,}$/.test(decoded);
      const isEmail = decoded.includes('@');
      const params = isPhone ? { phone: decoded } : isEmail ? { email: decoded } : { pseudo: decoded };
      api.lookupAnalysis(params)
        .then(res => {
          if (res.data?.id) {
            loadResult(res.data.id);
          } else {
            setError(t('result.notFoundError'));
          }
        })
        .catch(() => setError(t('result.notFoundError')));
    }
  }, [identifier, location.state, navigate]);

  // Update document title for client-side navigation
  useEffect(() => {
    if (!result) return;
    const verdicts = { legitimate: t('result.verdictLegitimate'), caution: t('result.verdictCaution'), suspicious: t('result.verdictSuspicious'), scam: t('result.verdictScam') };
    const sender = result.sender_email || result.sender_phone || result.sender_pseudo || result.sender_domain || 'Inconnu';
    document.title = `${sender} - ${verdicts[result.verdict] || result.verdict} (${result.risk_score}/100) | SpamSandbox`;
    return () => { document.title = 'SpamSandbox'; };
  }, [result]);

  if (error) {
    return (
      <div className="max-w-3xl mx-auto px-4 py-20 text-center">
        <div className="glass-card p-8">
          <svg className="w-16 h-16 mx-auto mb-4 text-danger" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
          </svg>
          <h2 className="text-xl text-white font-semibold mb-2">{t('common.error')}</h2>
          <p className="text-gray-400">{error}</p>
        </div>
      </div>
    );
  }

  if (!result) {
    return (
      <div className="max-w-3xl mx-auto px-4 py-20 text-center">
        <div className="w-8 h-8 border-2 border-safe border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="text-gray-400 mt-4">{t('result.loadingResults')}</p>
      </div>
    );
  }

  const verdictLabels = {
    legitimate: t('result.verdictLegitimate'),
    caution: t('result.verdictCaution'),
    suspicious: t('result.verdictSuspicious'),
    scam: t('result.verdictScam'),
  };

  const channelLabels = {
    email: { label: t('channels.email'), icon: '📧' },
    sms: { label: t('channels.sms'), icon: '💬' },
    whatsapp: { label: t('channels.whatsapp'), icon: '📱' },
    telegram: { label: t('channels.telegram'), icon: '✈️' },
    messenger: { label: t('channels.messenger'), icon: '💭' },
    instagram: { label: t('channels.instagram'), icon: '📷' },
    leboncoin: { label: t('channels.leboncoin'), icon: '🏷️' },
    marketplace: { label: t('channels.marketplace'), icon: '🛒' },
    vinted: { label: t('channels.vinted'), icon: '👗' },
    phone: { label: t('channels.phone'), icon: '📞' },
    website: { label: t('channels.website'), icon: '🌐' },
    other: { label: t('channels.other'), icon: '❓' },
  };
  const ch = channelLabels[result.channel] || channelLabels.email;

  const dangerSources = (result.sources || []).filter(s => s.status === 'danger');
  const warningSources = (result.sources || []).filter(s => s.status === 'warning');
  const safeSources = (result.sources || []).filter(s => s.status === 'safe');

  return (
    <div className="max-w-5xl mx-auto px-4 py-10">
      <div className="flex items-center justify-between mb-4">
        <Breadcrumb items={[
          { label: t('breadcrumb.home'), to: '/' },
          { label: t('breadcrumb.history'), to: '/history' },
          { label: result.sender_email || result.sender_domain || t('breadcrumb.analysis') },
        ]} />
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-gray-400 hover:text-safe transition-colors text-sm"
        >
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
          </svg>
          {t('common.back')}
        </button>
      </div>

      {/* Header with score */}
      <div className="glass-card p-8 mb-8">
        <div className="flex flex-col md:flex-row items-center gap-8">
          <ScoreRing score={result.risk_score} verdict={result.verdict} />

          <div className="flex-1 text-center md:text-left">
            <div className="flex items-center gap-3 justify-center md:justify-start mb-2">
              <span className={`badge-${result.verdict === 'scam' ? 'danger' : result.verdict === 'suspicious' ? 'suspicious' : result.verdict === 'caution' ? 'caution' : 'safe'} text-lg px-4 py-1.5`}>
                {verdictLabels[result.verdict] || result.verdict}
              </span>
              <span className="px-3 py-1 rounded-full text-xs font-medium bg-dark-surface border border-dark-border text-gray-300">
                {ch.icon} {ch.label}
              </span>
            </div>

            {/* Contextual badges */}
            {result.badges && result.badges.length > 0 && (
              <div className="flex flex-wrap gap-2 mb-3 justify-center md:justify-start">
                {result.badges.map((badge) => (
                  <span
                    key={badge.key}
                    title={badge.detail}
                    className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold border ${
                      badge.type === 'danger'
                        ? 'bg-danger/10 text-danger border-danger/30'
                        : badge.type === 'warning'
                        ? 'bg-caution/10 text-caution border-caution/30'
                        : badge.type === 'safe'
                        ? 'bg-safe/10 text-safe border-safe/30'
                        : 'bg-gray-500/10 text-gray-400 border-gray-600'
                    }`}
                  >
                    <BadgeIcon icon={badge.icon} />
                    {badge.label}
                  </span>
                ))}
              </div>
            )}

            <h1 className="text-2xl font-bold text-white mb-1">
              {result.subject || `Analyse de ${result.sender_email || result.sender_domain || 'expediteur inconnu'}`}
            </h1>

            <div className="space-y-1 text-sm">
              {result.sender_email && (
                <p className="text-gray-400">
                  <span className="text-gray-500">{t('result.from')}</span>{' '}
                  <span className="text-white font-mono">{result.sender_display_name && `${result.sender_display_name} `}</span>
                  <span className="text-safe font-mono">&lt;{result.sender_email}&gt;</span>
                </p>
              )}
              {result.sender_pseudo && (
                <p className="text-gray-400">
                  <span className="text-gray-500">{t('result.pseudo')}</span>{' '}
                  <span className="text-white font-mono">{result.sender_pseudo}</span>
                </p>
              )}
              {result.sender_phone && (
                <p className="text-gray-400">
                  <span className="text-gray-500">{t('result.phone')}</span>{' '}
                  <span className="text-white font-mono">{result.sender_phone}</span>
                </p>
              )}
              {result.reply_to && result.reply_to !== result.sender_email && (
                <p className="text-caution">
                  <span className="text-gray-500">Reply-To :</span>{' '}
                  <span className="font-mono">{result.reply_to}</span>
                  <span className="text-xs ml-2">{t('result.replyToDifferent')}</span>
                </p>
              )}
              <p className="text-gray-500">
                {t('result.domain')} <span className="font-mono text-gray-300">{result.sender_domain}</span>
                {result.sending_ip && <> | {t('result.ip')} <span className="font-mono text-gray-300">{result.sending_ip}</span></>}
              </p>
            </div>

            {result.scan_duration && (
              <p className="text-gray-500 text-xs mt-2">
                {t('result.analyzedIn', { duration: result.scan_duration })} | {new Date(result.created_at).toLocaleString()}
              </p>
            )}
          </div>
        </div>
      </div>

      {/* First detection & times reported banner */}
      {(result.first_detected_at || result.times_reported > 0) && (
        <div className="glass-card p-5 mb-8 border-l-4 border-caution/50 bg-caution/5">
          <div className="flex items-center gap-3 mb-2">
            <svg className="w-5 h-5 text-caution" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <h3 className="text-white font-semibold">{t('result.detectionHistory')}</h3>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
            {result.first_detected_at && (
              <div>
                <span className="text-gray-500">{t('result.firstDetection')}</span>
                <span className="text-caution font-mono ml-2">
                  {new Date(result.first_detected_at).toLocaleDateString('fr-FR', {
                    day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit'
                  })}
                </span>
              </div>
            )}
            {result.times_reported > 0 && (
              <div>
                <span className="text-gray-500">{t('result.timesReported')}</span>
                <span className="text-white font-bold ml-2">{result.times_reported}</span>
              </div>
            )}
            {result.first_seen_exact && (
              <div>
                <span className="text-gray-500">{t('result.identicalEmail')}</span>
                <span className="text-danger font-mono ml-2">
                  {new Date(result.first_seen_exact).toLocaleDateString('fr-FR')}
                </span>
              </div>
            )}
            {result.ioc_matches_count > 0 && (
              <div>
                <span className="text-gray-500">{t('result.knownIOCs')}</span>
                <span className="text-danger font-bold ml-2">{result.ioc_matches_count}</span>
              </div>
            )}
          </div>
          {result.first_seen_sender_domain && result.first_seen_sender_domain !== result.first_seen_exact && (
            <p className="text-gray-400 text-xs mt-2">
              {t('result.domainFirstSeen', { date: new Date(result.first_seen_sender_domain).toLocaleDateString() })}
            </p>
          )}
          {result.first_seen_ioc && (
            <p className="text-gray-400 text-xs mt-1">
              {t('result.firstIOC', { date: new Date(result.first_seen_ioc).toLocaleDateString() })}
            </p>
          )}
        </div>
      )}

      {/* Smart Summary - always open */}
      {result.smart_summary && (
        <div className="mb-6">
          <SmartSummary summary={result.smart_summary} verdict={result.verdict} score={result.risk_score} />
        </div>
      )}

      {/* Modus Operandi matches */}
      {result.mo_matches && result.mo_matches.length > 0 && (
        <div className="mb-6">
          <CollapsibleSection
            title={t('result.modusOperandi')}
            tooltip={t('result.moTooltip')}
            badge={t('result.patterns', { count: result.mo_matches.length })}
            defaultOpen={true}
            icon={
              <svg className="w-5 h-5 text-danger" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
              </svg>
            }
          >
            <div className="space-y-4">
              {result.mo_matches.map((match, i) => (
                <div key={i} className="bg-dark-surface/50 rounded-lg p-4 border border-danger/20">
                  <div className="flex items-center justify-between mb-2">
                    <h4 className="text-white font-medium">{match.name}</h4>
                    <div className="flex items-center gap-2">
                      <span className="text-xs text-gray-400 uppercase">{match.category}</span>
                      <span className={`px-2 py-0.5 rounded text-xs font-bold ${
                        match.confidence >= 0.7 ? 'bg-danger/20 text-danger' :
                        match.confidence >= 0.5 ? 'bg-caution/20 text-caution' :
                        'bg-gray-700 text-gray-300'
                      }`}>
                        {t('result.match', { pct: Math.round(match.confidence * 100) })}
                      </span>
                    </div>
                  </div>
                  <p className="text-gray-400 text-sm mb-3">{match.description}</p>
                  {match.matched_keywords?.length > 0 && (
                    <div className="flex flex-wrap gap-1">
                      {match.matched_keywords.map((kw, j) => (
                        <span key={j} className="bg-danger/10 text-danger text-xs px-2 py-0.5 rounded">{kw}</span>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </CollapsibleSection>
        </div>
      )}

      {/* User context */}
      {result.user_context && (
        <div className="mb-6 glass-card p-5 border-l-4 border-accent-cyan/50">
          <div className="flex items-center gap-2 mb-2">
            <svg className="w-5 h-5 text-accent-cyan" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
            </svg>
            <h3 className="text-white font-semibold">{t('result.userTestimony')}</h3>
          </div>
          <p className="text-gray-300 text-sm whitespace-pre-wrap">{result.user_context}</p>
        </div>
      )}

      {/* Body preview */}
      {result.body_preview && (
        <div className="mb-6">
          <CollapsibleSection
            title={t('result.bodyPreview')}
            icon={
              <svg className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
              </svg>
            }
          >
            <p className="text-gray-400 text-sm font-mono whitespace-pre-wrap bg-dark-surface/50 rounded-lg p-4 max-h-64 overflow-y-auto">
              {result.body_preview}
            </p>
          </CollapsibleSection>
        </div>
      )}

      {/* Domain emails discovered */}
      {result.domain_emails_result && result.domain_emails_result.total_found > 0 && (
        <div className="mb-6">
          <CollapsibleSection
            title={t('result.domainEmails')}
            tooltip={t('result.domainEmailsTooltip')}
            badge={t('result.emails', { count: result.domain_emails_result.total_found })}
            icon={
              <svg className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
              </svg>
            }
          >
            <DomainEmailsCard data={result.domain_emails_result} embedded />
          </CollapsibleSection>
        </div>
      )}

      {/* Source results - Danger */}
      {dangerSources.length > 0 && (
        <div className="mb-6">
          <CollapsibleSection
            title={t('result.criticalAlerts')}
            tooltip={t('result.criticalAlertsTooltip')}
            badge={t('result.sources', { count: dangerSources.length })}
            defaultOpen={true}
            icon={
              <svg className="w-5 h-5 text-danger" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
              </svg>
            }
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {dangerSources.map((source, i) => (
                <SourceCard key={i} source={source} />
              ))}
            </div>
          </CollapsibleSection>
        </div>
      )}

      {/* Source results - Warning */}
      {warningSources.length > 0 && (
        <div className="mb-6">
          <CollapsibleSection
            title={t('result.warnings')}
            tooltip={t('result.warningsTooltip')}
            badge={t('result.sources', { count: warningSources.length })}
            defaultOpen={false}
            icon={
              <svg className="w-5 h-5 text-caution" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m0 3.75h.008v.008H12v-.008zM21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            }
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {warningSources.map((source, i) => (
                <SourceCard key={i} source={source} />
              ))}
            </div>
          </CollapsibleSection>
        </div>
      )}

      {/* Source results - Safe */}
      {safeSources.length > 0 && (
        <div className="mb-6">
          <CollapsibleSection
            title={t('result.positiveSignals')}
            tooltip={t('result.positiveSignalsTooltip')}
            badge={t('result.sources', { count: safeSources.length })}
            defaultOpen={false}
            icon={
              <svg className="w-5 h-5 text-safe" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            }
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {safeSources.map((source, i) => (
                <SourceCard key={i} source={source} />
              ))}
            </div>
          </CollapsibleSection>
        </div>
      )}

      {/* Extracted entities */}
      {result.extracted_entities && result.extracted_entities.length > 0 && (
        <div className="mb-6">
          <CollapsibleSection
            title={t('result.extractedEntities')}
            tooltip={t('result.entitiesTooltip')}
            badge={`${result.extracted_entities.length}`}
            icon={
              <svg className="w-5 h-5 text-safe" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m5.231 13.481L15 17.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v16.5c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
              </svg>
            }
          >
            <EntityList entities={result.extracted_entities} embedded />
          </CollapsibleSection>
        </div>
      )}

      {/* Similar/correlated emails */}
      {result.email_correlation_result?.related_analyses?.length > 0 && (
        <div className="mb-6">
          <CollapsibleSection
            title={t('result.similarEmails')}
            tooltip={t('result.similarTooltip')}
            badge={`${result.email_correlation_result.related_analyses.length}`}
            icon={
              <svg className="w-5 h-5 text-caution" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m9.86-2.06a4.5 4.5 0 00-6.364-6.364L4.5 8.257" />
              </svg>
            }
          >
            <div className="space-y-2">
              {result.email_correlation_result.related_analyses.map((rel, i) => (
                <div key={i} className="flex items-center justify-between py-2 border-b border-dark-border last:border-0">
                  <div>
                    <span className="text-gray-300 text-sm">{rel.sender}</span>
                    <span className="text-gray-500 text-xs ml-2">{rel.subject}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="font-mono text-sm text-gray-400">{rel.risk_score}/100</span>
                    <span className={`badge-${rel.verdict === 'scam' ? 'danger' : rel.verdict === 'suspicious' ? 'suspicious' : 'safe'} text-xs`}>
                      {rel.verdict}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </CollapsibleSection>
        </div>
      )}

      {/* Community report section */}
      {result.sender_domain && (
        <div className="mb-6">
          <CommunityReportSection
            senderDomain={result.sender_domain}
            senderEmail={result.sender_email}
            subject={result.subject}
            channel={result.channel}
          />
        </div>
      )}

      {/* Export + Removal buttons */}
      <div className="flex flex-wrap gap-4 justify-center">
        <a
          href={`/api/v1/analyze/${result.id}/export/?format=json`}
          className="btn-secondary text-sm flex items-center gap-1.5"
          download
        >
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />
          </svg>
          {t('result.exportJSON')}
        </a>
        <a
          href={`/api/v1/analyze/${result.id}/export/?format=csv`}
          className="btn-secondary text-sm flex items-center gap-1.5"
          download
        >
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />
          </svg>
          {t('result.exportCSV')}
        </a>
        <RemovalButton analysisId={result.id} />
      </div>

      {/* SEO internal links */}
      {result.sender_domain && (
        <div className="mt-8 glass-card p-6">
          <h3 className="text-white font-semibold mb-3">{t('result.learnMore')}</h3>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/community" className="text-safe hover:underline">
              {t('result.communityLink')}
            </Link>
            <a href="/faq/" className="text-safe hover:underline">
              {t('result.howToRead')}
            </a>
            <Link to="/" className="text-safe hover:underline">
              {t('result.analyzeAnother')}
            </Link>
          </div>
        </div>
      )}
    </div>
  );
}

function CommunityReportSection({ senderDomain, senderEmail, subject, channel }) {
  const { t } = useTranslation();
  const [reports, setReports] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({
    report_type: 'scam', description: '', money_lost: '',
    profile_pseudo: '', author_name: '',
  });
  const [submitMsg, setSubmitMsg] = useState(null);

  useEffect(() => {
    if (senderDomain) {
      api.getReports(senderDomain).then(r => {
        setReports(r.data?.results || r.data || []);
      }).catch(() => {});
    }
  }, [senderDomain]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitMsg(null);
    try {
      const data = {
        sender_domain: senderDomain,
        sender_email: senderEmail || '',
        subject_snippet: (subject || '').slice(0, 200),
        channel: channel || 'email',
        report_type: form.report_type,
        description: form.description,
        money_lost: form.money_lost ? parseFloat(form.money_lost) : null,
        profile_pseudo: form.profile_pseudo,
        author_name: form.author_name || t('common.anonymous'),
      };
      const res = await api.submitReport(data);
      const xp = res.data.xp_earned || 0;
      const badges = res.data.new_badges || [];
      let msg = t('reportForm.success');
      if (xp > 0) msg += ` ${t('reportForm.xpEarned', { xp })}`;
      if (badges.length > 0) msg += ` | ${t('reportForm.newBadges', { badges: badges.join(', ') })}`;
      setSubmitMsg({ type: 'success', text: msg });
      setShowForm(false);
      setForm({ report_type: 'scam', description: '', money_lost: '', profile_pseudo: '', author_name: '' });
      // Refresh reports
      api.getReports(senderDomain).then(r => setReports(r.data?.results || r.data || [])).catch(() => {});
    } catch (err) {
      setSubmitMsg({ type: 'error', text: err.message || t('common.error') });
    }
  };

  const handleUpvote = async (reportId) => {
    try {
      const res = await api.upvoteReport(reportId);
      setReports(prev => prev.map(r =>
        r.id === reportId ? { ...r, upvotes: res.data.upvotes } : r
      ));
    } catch (err) {
      // Already voted or error — ignore silently
    }
  };

  return (
    <div className="glass-card p-6">
      {/* Header */}
      <div className="flex items-center justify-between mb-5">
        <div className="flex items-center gap-2">
          <svg className="w-5 h-5 text-safe" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z" />
          </svg>
          <h2 className="text-white font-semibold text-lg">{t('result.communityReports')}</h2>
          {reports.length > 0 && (
            <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-safe/10 text-safe border border-safe/30">
              {reports.length}
            </span>
          )}
        </div>
      </div>

      {/* Report form — toggle button */}
      {submitMsg && (
        <div className={`text-sm mb-4 p-3 rounded-lg ${submitMsg.type === 'success' ? 'text-safe bg-safe/10 border border-safe/20' : 'text-danger bg-danger/10 border border-danger/20'}`}>
          {submitMsg.text}
        </div>
      )}

      {!showForm && (
        <button
          onClick={() => setShowForm(true)}
          className="btn-secondary text-sm mb-6 flex items-center gap-2"
        >
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
          </svg>
          {t('result.addReport')}
        </button>
      )}

      {showForm && (
        <form onSubmit={handleSubmit} className="mb-6">
          <div className="flex gap-3 mb-3">
            <select
              value={form.report_type}
              onChange={e => setForm({ ...form, report_type: e.target.value })}
              className="bg-dark-surface border border-dark-border rounded-lg px-3 py-2.5 text-white text-sm focus:border-safe focus:outline-none"
            >
              <option value="scam">{t('reportForm.scam')}</option>
              <option value="phishing">{t('reportForm.phishing')}</option>
              <option value="spam">{t('reportForm.spam')}</option>
              <option value="malware">{t('reportForm.malware')}</option>
              <option value="legitimate">{t('reportForm.legitimate')}</option>
              <option value="other">{t('reportForm.other')}</option>
            </select>
            <input
              type="text" placeholder={t('reportForm.pseudoPlaceholder')}
              value={form.profile_pseudo}
              onChange={e => setForm({ ...form, profile_pseudo: e.target.value })}
              className="bg-dark-surface border border-dark-border rounded-lg px-3 py-2.5 text-white text-sm placeholder-gray-500 focus:border-safe focus:outline-none flex-1"
            />
            <input
              type="number" step="0.01" min="0" placeholder={t('reportForm.moneyLost')}
              value={form.money_lost}
              onChange={e => setForm({ ...form, money_lost: e.target.value })}
              className="bg-dark-surface border border-dark-border rounded-lg px-3 py-2.5 text-white text-sm placeholder-gray-500 focus:border-safe focus:outline-none w-32"
            />
          </div>
          <div className="flex gap-3">
            <textarea
              placeholder={t('reportForm.descPlaceholder')}
              value={form.description}
              onChange={e => setForm({ ...form, description: e.target.value })}
              required minLength={10} maxLength={2000} rows={2}
              className="flex-1 bg-dark-surface border border-dark-border rounded-lg px-3 py-2.5 text-white text-sm placeholder-gray-500 focus:border-safe focus:outline-none resize-none"
            />
            <button type="submit" className="btn-primary text-sm px-6 self-end">
              {t('reportForm.submit')}
            </button>
          </div>
        </form>
      )}

      {/* Existing reports */}
      {reports.length > 0 && (
        <div className="space-y-3 border-t border-dark-border pt-4">
          {reports.slice(0, 10).map((report) => (
            <ReportCard key={report.id} report={report} onUpvote={handleUpvote} onReplyAdded={(reportId, reply) => {
              setReports(prev => prev.map(r =>
                r.id === reportId ? { ...r, replies: [...(r.replies || []), reply] } : r
              ));
            }} />
          ))}
        </div>
      )}
    </div>
  );
}

function ReportCard({ report, onUpvote, onReplyAdded }) {
  const { t } = useTranslation();
  const [showReply, setShowReply] = useState(false);
  const [replyText, setReplyText] = useState('');
  const [replyPseudo, setReplyPseudo] = useState('');
  const [replying, setReplying] = useState(false);

  const handleReply = async (e) => {
    e.preventDefault();
    if (replying) return;
    setReplying(true);
    try {
      const res = await api.replyToReport(report.id, {
        content: replyText,
        profile_pseudo: replyPseudo,
      });
      onReplyAdded(report.id, res.data);
      setReplyText('');
      setShowReply(false);
    } catch (err) {
      // ignore
    }
    setReplying(false);
  };

  return (
    <div className="p-3 bg-dark-surface/30 rounded-lg">
      <div className="flex items-start gap-3">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <span className="text-white text-sm font-medium">
              {report.profile_mini?.pseudo || report.author_name || t('common.anonymous')}
            </span>
            <span className={`text-xs px-1.5 py-0.5 rounded ${
              report.report_type === 'scam' ? 'bg-danger/20 text-danger' :
              report.report_type === 'phishing' ? 'bg-orange-500/20 text-orange-400' :
              report.report_type === 'legitimate' ? 'bg-safe/20 text-safe' :
              'bg-gray-600/20 text-gray-400'
            }`}>
              {report.report_type}
            </span>
            {report.is_verified && <span className="text-xs text-cyan-400">verifie</span>}
            <span className="text-gray-600 text-xs">{new Date(report.created_at).toLocaleDateString('fr-FR')}</span>
          </div>
          <p className="text-gray-400 text-sm">{report.description}</p>
          {report.money_lost > 0 && (
            <p className="text-danger text-xs mt-1">{report.money_lost} {report.currency} perdus</p>
          )}
          <div className="flex items-center gap-4 mt-2">
            <button
              onClick={() => onUpvote(report.id)}
              className="text-gray-500 hover:text-safe transition-colors flex items-center gap-1 text-xs"
            >
              <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 15.75l7.5-7.5 7.5 7.5" />
              </svg>
              {report.upvotes}
            </button>
            <button
              onClick={() => setShowReply(!showReply)}
              className="text-gray-500 hover:text-safe transition-colors flex items-center gap-1 text-xs"
            >
              <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 20.25c4.97 0 9-3.694 9-8.25s-4.03-8.25-9-8.25S3 7.444 3 12c0 2.104.859 4.023 2.273 5.48.432.447.74 1.04.586 1.641a4.483 4.483 0 01-.923 1.785A5.969 5.969 0 006 21c1.282 0 2.47-.402 3.445-1.087.81.22 1.668.337 2.555.337z" />
              </svg>
              Repondre{(report.replies?.length > 0) ? ` (${report.replies.length})` : ''}
            </button>
          </div>
        </div>
      </div>

      {/* Replies */}
      {report.replies?.length > 0 && (
        <div className="ml-6 mt-3 space-y-2 border-l-2 border-dark-border pl-3">
          {report.replies.map((reply) => (
            <div key={reply.id} className="text-sm">
              <span className="text-white font-medium">{reply.profile_mini?.pseudo || reply.author_name}</span>
              <span className="text-gray-600 text-xs ml-2">{new Date(reply.created_at).toLocaleDateString('fr-FR')}</span>
              <p className="text-gray-400 text-sm">{reply.content}</p>
            </div>
          ))}
        </div>
      )}

      {/* Reply form */}
      {showReply && (
        <form onSubmit={handleReply} className="ml-6 mt-3 flex gap-2">
          <input
            type="text" placeholder={t('reportForm.pseudoPlaceholder')}
            value={replyPseudo}
            onChange={e => setReplyPseudo(e.target.value)}
            className="bg-dark-surface border border-dark-border rounded-lg px-2.5 py-1.5 text-white text-xs placeholder-gray-500 focus:border-safe focus:outline-none w-28"
          />
          <input
            type="text" placeholder={t('reportForm.descPlaceholder')}
            value={replyText}
            onChange={e => setReplyText(e.target.value)}
            required minLength={3} maxLength={1000}
            className="flex-1 bg-dark-surface border border-dark-border rounded-lg px-2.5 py-1.5 text-white text-xs placeholder-gray-500 focus:border-safe focus:outline-none"
          />
          <button type="submit" disabled={replying} className="btn-primary text-xs px-3 py-1.5">
            {replying ? '...' : t('common.submit')}
          </button>
        </form>
      )}
    </div>
  );
}

function RemovalButton({ analysisId }) {
  const { t } = useTranslation();
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ requester_email: '', requester_name: '', reason: 'owner', details: '' });
  const [msg, setMsg] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [confirming, setConfirming] = useState(false);
  const confirmTimerRef = React.useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!confirming) {
      setConfirming(true);
      confirmTimerRef.current = setTimeout(() => setConfirming(false), 5000);
      return;
    }
    // Second click — actually submit
    clearTimeout(confirmTimerRef.current);
    setConfirming(false);
    setMsg(null);
    try {
      await api.requestRemoval(analysisId, form);
      setMsg({ type: 'success', text: t('result.removalSent') });
      setSubmitted(true);
      setShowForm(false);
    } catch (err) {
      setMsg({ type: 'error', text: err.message || t('common.error') });
    }
  };

  if (submitted) {
    return <span className="text-safe text-sm">{t('result.removalSent')}</span>;
  }

  return (
    <>
      <button
        onClick={() => setShowForm(!showForm)}
        className="text-gray-500 hover:text-gray-300 text-sm transition-colors flex items-center gap-1"
      >
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
        </svg>
        {t('result.requestRemoval')}
      </button>

      {showForm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm" onClick={() => setShowForm(false)}>
          <div className="glass-card p-6 max-w-md w-full mx-4" onClick={e => e.stopPropagation()}>
            <h3 className="text-white font-semibold text-lg mb-4">{t('result.removalTitle')}</h3>
            <p className="text-gray-400 text-sm mb-4">
              {t('result.removalDesc')}
            </p>

            {msg && (
              <div className={`text-sm mb-3 p-2 rounded ${msg.type === 'success' ? 'text-safe bg-safe/10' : 'text-danger bg-danger/10'}`}>
                {msg.text}
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-3">
              <input
                type="email" placeholder={`${t('result.removalEmail')} *`} required
                value={form.requester_email}
                onChange={e => setForm({ ...form, requester_email: e.target.value })}
                className="w-full bg-dark-surface border border-dark-border rounded-lg px-3 py-2 text-white text-sm placeholder-gray-500 focus:border-safe focus:outline-none"
              />
              <input
                type="text" placeholder={t('result.removalDetails')}
                value={form.requester_name}
                onChange={e => setForm({ ...form, requester_name: e.target.value })}
                className="w-full bg-dark-surface border border-dark-border rounded-lg px-3 py-2 text-white text-sm placeholder-gray-500 focus:border-safe focus:outline-none"
              />
              <select
                value={form.reason}
                onChange={e => setForm({ ...form, reason: e.target.value })}
                className="w-full bg-dark-surface border border-dark-border rounded-lg px-3 py-2 text-white text-sm focus:border-safe focus:outline-none"
              >
                <option value="owner">{t('removalReasons.owner')}</option>
                <option value="privacy">{t('removalReasons.privacy')}</option>
                <option value="false_positive">{t('removalReasons.false_positive')}</option>
                <option value="legal">{t('removalReasons.legal')}</option>
                <option value="other">{t('removalReasons.other')}</option>
              </select>
              <textarea
                placeholder={t('result.removalDetails')}
                value={form.details}
                onChange={e => setForm({ ...form, details: e.target.value })}
                rows={3} maxLength={2000}
                className="w-full bg-dark-surface border border-dark-border rounded-lg px-3 py-2 text-white text-sm placeholder-gray-500 focus:border-safe focus:outline-none resize-none"
              />
              <div className="flex gap-2">
                <button type="submit" className={`text-sm flex-1 ${confirming ? 'bg-danger hover:bg-danger/80 text-white font-semibold px-4 py-2 rounded-lg transition-colors' : 'btn-primary'}`}>
                  {confirming ? t('result.confirmRemoval') : t('result.sendRequest')}
                </button>
                <button type="button" onClick={() => { setShowForm(false); setConfirming(false); clearTimeout(confirmTimerRef.current); }} className="btn-secondary text-sm">{t('common.cancel')}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
